import { DriverStatisticsType } from '@sky-it-livedata/livedata-sports-design-system';
import { DriverStatsWidget } from 'cdk/graphql'

export type DriverStatisticsQuery = {
  data: {
    getDriverStatsWidget: DriverStatsWidget;
  };
};

export const statsOrder: DriverStatisticsType[] = [
  'Ranking',
  'Points',
  'Races',
  'GpPoints',
  'Victories',
  'Podiums',
  'RacesWithPoints',
  'TopTen',
  'Poles',
  'Dnfs',
  'SprintRaces',
  'SprintPoints',
  'SprintVictories',
  'SprintPodiums',
  'SprintPoles',
  'SprintTopTen',
];